import AdyenForm from 'components/pages/checkout/CheckoutView/Payment/paymentMethods/Adyen/AdyenForm';
import CheckoutSection from 'components/pages/checkout/CheckoutSection';
import Heading from 'components/text/Heading';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const AdyenFormWrapper = ({
    scrollToShippingSection,
    setShowShippingAndPayment,
    showShippingAndPayment,
    tracking = {},
}) => {
    const heading = useSelector(state => state.page.data.checkout.address.heading || {});

    return (
        <CheckoutSection>
            {heading && <Heading to={heading.type}>{heading.text}</Heading>}
            <AdyenForm
                scrollToShippingSection={scrollToShippingSection}
                setShowShippingAndPayment={setShowShippingAndPayment}
                showShippingAndPayment={showShippingAndPayment}
                tracking={tracking}
            />
        </CheckoutSection>
    );
};

AdyenFormWrapper.propTypes = {
    scrollToShippingSection: PropTypes.func.isRequired,
    setShowShippingAndPayment: PropTypes.func.isRequired,
    showShippingAndPayment: PropTypes.bool,
    tracking: PropTypes.shape({
        trigger: PropTypes.bool,
        setTrigger: PropTypes.func,
    }),
};

export default AdyenFormWrapper;
